import { Pagination } from 'antd';
import React from 'react';

interface ICustomTableWithPaginationProps {
  children: React.ReactNode;
  total?: number;
  page: number;
  limit: number;
  onPageChange: (page: number, pageSize: number) => void;
}

const CustomTableWithPagination: React.FC<ICustomTableWithPaginationProps> = ({
  children,
  total,
  page,
  limit,
  onPageChange,
}) => {
  return (
    <div>
      {/* Table as a child */}
      <div style={{ border: '1px solid #DEEEF8', borderRadius: '4px', overflow: 'hidden' }}>
        {children}
      </div>

      {/* Pagination */}
      <Pagination
        defaultPageSize={10}
        showSizeChanger
        total={total}
        current={page}
        pageSize={limit}
        onChange={onPageChange}
        style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}
      />
    </div>
  );
};

export default CustomTableWithPagination;
